<template>
  <div class="searchInput">
    <form action="" @submit.prevent="onSearch" class="searchForm">
      <input
        v-model="value"
        type="search"
        ref="searchKey"
        :placeholder="placeholder ? placeholder : '请输入姓名或者手机号查询'"
      />
    </form>
    <van-icon name="search" class="searchIcon" size="20" />
    <van-icon
      name="clear"
      class="clearIcon"
      v-show="value"
      @click="value = ''"
    />
    <div class="searchButton" @click="onSearch()">搜索</div>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: String,
    immediately: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: '',
      search: false,
      timeId: null
    }
  },
  watch: {
    value(newName, oldName) {
      if (this.immediately) {
        clearTimeout(this.timeId) // 清除定时器
        this.timeId = setTimeout(() => {
          this.onSearch()
        }, 600)
      } else {
        if (newName === '' && this.search) {
          this.onSearch()
          this.search = false
        }
      }
    }
  },
  methods: {
    onSearch() {
      if (!this.immediately) {
        this.$refs.searchKey.blur()
      }
      this.$emit('search', this.value)
      this.search = true
    },
    clear() {
      this.value = ''
    }
  }
}
</script>
<style lang="scss" scoped>
input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.searchInput {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  margin-top: 10px;
  .searchForm {
    width: 100%;
    height: 36px;
  }
  input {
    width: calc(100% - 40px);
    height: 100%;
    border-radius: 18px;
    border: none;
    background-color: rgb(230, 230, 230);
    padding: 0 60px 0 40px;
  }
  input::placeholder {
    font-size: 15px;
  }
  input[type='search'] {
    -webkit-appearance: none;
  }
  input::-webkit-search-cancel-button {
    display: none;
  }
  .searchIcon {
    position: absolute;
    left: 15px;
  }
  .clearIcon {
    position: absolute;
    right: 80px;
  }
  .searchButton {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0px;
    top: 0px;
    width: 70px;
    height: 100%;
    font-size: 15px;
    color: #fff;
    border-radius: 18px;
    background-color: #a30014;
  }
}
</style>
